<template>
  <div id="boxDrop" :class="['box_drop',{ active : isShowDropBox, box_drop_layer : isLayer }]" :style="cssProps" @click.self="onClickDrop()">
    <div
      class="inner_box_drop"
      ref="innerBoxDrop">
      <ul
        v-if="tiemDataList.H.dataList.length > 0"
        class="list_option"
        ref="scrollBodyH">
        <li
          v-for="item in tiemDataList.H.dataList"
          :key="item.id"
          :class="{ active: isActive(item.id,'H'), disabled : item.isDisabled }">
          <button
            class="btn_option"
            :disabled="item.isDisabled"
            @click="onClickOption(item.id,'H')">
            <p v-if="item.info_head" class="desc_info" v-html="item.info_head"></p>
            <span class="txt_option">{{ item.text }}</span>
            <IconSvg v-if="isActive(item.id,'H')" iconName="check" size="12" iconColor="PRIMARY_COLOR"/>
            <p v-if="item.info" class="desc_info" v-html="item.info"></p>
          </button>
        </li>
      </ul>
      <ul
        v-if="tiemDataList.M.dataList.length > 0"
        class="list_option"
        ref="scrollBodyM">
        <li
          v-for="item in tiemDataList.M.dataList"
          :key="item.id"
          :class="{ active: isActive(item.id,'M'), disabled : item.isDisabled }">
          <button
            class="btn_option"
            :disabled="item.isDisabled"
            @click="onClickOption(item.id,'M')">
            <p v-if="item.info_head" class="desc_info" v-html="item.info_head"></p>
            <span class="txt_option">{{ item.text }}</span>
            <IconSvg v-if="isActive(item.id,'M')" iconName="check" size="12" iconColor="PRIMARY_COLOR"/>
            <p v-if="item.info" class="desc_info" v-html="item.info"></p>
          </button>
        </li>
      </ul>
      <ul
        v-if="tiemDataList.S.dataList.length > 0"
        class="list_option"
        ref="scrollBodyS">
        <li
          v-for="item in tiemDataList.S.dataList"
          :key="item.id"
          :class="{ active: isActive(item.id,'S'), disabled : item.isDisabled }">
          <button
            class="btn_option"
            :disabled="item.isDisabled"
            @click="onClickOption(item.id,'S')">
            <p v-if="item.info_head" class="desc_info" v-html="item.info_head"></p>
            <span class="txt_option">{{ item.text }}</span>
            <IconSvg v-if="isActive(item.id,'S')" iconName="check" size="12" iconColor="PRIMARY_COLOR"/>
            <p v-if="item.info" class="desc_info" v-html="item.info"></p>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconSvg from '@lemontree-ai/lemontree-admin-common-front/components/common/icon/IconSvg';
import { getDocumentElementPositon, getDocumentElementPopop } from '@lemontree-ai/lemontree-admin-common-front/utils/elementUtils';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'DropBoxTime',
  components: {
    IconSvg
  },
  data(){
    return{
      isShowDropBox: false,
      itemDefaultHeight: this.isHasInfo ? 62 : 44,
      spaceMargin: 8,
      dropBoxPosition:{
        width:0,
        top:0,
        bottom:0,
        left:0,
      },
      isLayer: false,
      tiemDataList:{
        H:{
          dataList:[],
        },
        M:{
          dataList:[],
        },
        S:{
          dataList:[],
        }
      },
      hourDataList:[],
      minuteDataList:[],
      secoundDataList:[],
    }
  },
  beforeMount(){
    this.setDataList();
  },
  mounted() {
    this.dropBoxActive();
    this.setDropBoxPosition();
    this.setScrollReset();
  },
  beforeUnmount() {
    this.isShowDropBox = false;
    if (this.dropBoxActive) clearTimeout(this.dropBoxActive);
  },
  computed: {
    ...mapGetters('commonViewport', [ 'getWindowWidth', 'getWindowHeight', 'getScrollTop', 'getLayerScrollTop', 'getLayerBodyPosition' ]),
    ...mapGetters('commonDropBox', [ 'getDropBoxUid', 'getIsTimeDropBox', 'getDropBoxDataList', 'getDropBoxTarget', 'getDropBoxTargetHeight', 'getDropBoxOption','getDropBoxSeletData', 'getDropBoxValue']),
    isHasInfoHead(){
      return Boolean(this.getDropBoxDataList.find(item => item.info_head));
    },
    isHasInfo(){
      return Boolean(this.getDropBoxDataList.find(item => item.info));
    },
    dropBoxHeight(){
      if(!this.getDropBoxOption || !this.getDropBoxOption.showLine) return 236;
      const itemHeight = 44 + ( this.isHasInfo ?  18 : 0 ) + ( this.isHasInfoHead ?  18 : 0 );
      return this.getDropBoxOption.showLine * itemHeight;
    },
    cssProps(){
      var obj = {};
      obj = {
        '--top': `${this.dropBoxPosition.top}${this.dropBoxPosition.top != 'inherit' ? 'px' : ''}`,
        '--bottom': `${this.dropBoxPosition.bottom}${this.dropBoxPosition.bottom != 'inherit' ? 'px' : ''}`,
        '--left': `${this.dropBoxPosition.left}px`,
        '--width': `${this.dropBoxPosition.width}px`,
        '--height': `${(this.dropBoxHeight)}px`,
      }
      return obj;
    },
    isInPopup(){
      return getDocumentElementPopop(this.getDropBoxTarget);
    }
  },
  watch:{
    getDropBoxUid(){
      if(this.getDropBoxUid === null) return;
      this.setDropBoxPosition();
      this.setScrollReset();
    },
    getIsTimeDropBox(){
      if(this.getIsTimeDropBox){
        this.setScrollReset();
      }
    },
    getWindowWidth(){
      this.setDropBoxPosition();
    },
    getWindowHeight(){
      this.setDropBoxPosition();
    },
    getScrollTop(){
      this.setDropBoxPosition();
    },
    getLayerScrollTop(){
      this.setDropBoxPosition();
    },
    getDropBoxTargetHeight(){
      this.setDropBoxPosition();
    },
    getDropBoxValue(){
      this.setScrollReset();
    },
  },
  update(){
    console.log('update',this.getDropBoxTarget.offsetHeight)
  },
  methods:{
    ...mapActions('commonDropBox', [ 'fetchDropBoxSelect', 'fetchDropBoxEnd' ]),
    setDataList(){
      const minHour = this.getDropBoxOption.minHour || 0;
      const maxHour = this.getDropBoxOption.maxHour || 23;
      for(let hour = minHour; hour <= maxHour; hour++){
        let hourValString = String(hour);
        if(hour < 10){
          hourValString = `0${hourValString}`;
        }
        const rObj = { id:hourValString, text:hourValString }
        this.tiemDataList.H.dataList.push(rObj)
      }
      for(let minute = 0; minute <= 59; minute++){
        let minuteValString = String(minute);
        if(minute < 10){
          minuteValString = `0${minuteValString}`;
        }
        const rObj = { id:minuteValString, text:minuteValString }
        this.tiemDataList.M.dataList.push(rObj);
        this.tiemDataList.S.dataList.push(rObj);
      }
    },
    dropBoxActive(){
      const _this = this;
      this.timeoutID0 = setTimeout(function(){
        _this.isShowDropBox = true;
        this.timeoutID0 = null;
      }, 50);
    },
    setScrollReset(){
      // if(!this.$refs.scrollBody) return;
      if(this.getDropBoxValue && !this.getDropBoxOption.canMultiple){
        const valueList = ['H','M','S'];
        valueList.forEach(valueKey => {
          const selectedIndex = this.tiemDataList[valueKey].dataList.findIndex(item => item.id === this.getDropBoxValue[valueKey]);
          this.$refs['scrollBody'+valueKey].scrollTop = ( 44*selectedIndex ) - (this.dropBoxHeight/2) + 22;
        })
      }else{
        this.$refs.scrollBody.scrollTop = 0;
      }
    },
    setDropBoxPosition(){
      if(!this.getDropBoxTarget) return;
      const elementOffset = getDocumentElementPositon(this.getDropBoxTarget);
      const isInPopupScroll = -this.getLayerScrollTop + this.getScrollTop; // 팝업내에 있을 경우 scroll값 추가
      const dropBoxTop = this.getDropBoxTarget.offsetHeight + elementOffset.top; // 드롭박스 top 위치값

      // 선택영역 보이는 화면 벗어낫을때 닫기
      const targetTop = elementOffset.top + (this.isInPopup ? isInPopupScroll : 0);
      const targetBottom = dropBoxTop + (this.isInPopup ? isInPopupScroll : 0);
      const targetAreaTop = this.isInPopup ? this.getLayerBodyPosition.top : this.getScrollTop + 60;
      const targetAreaBottom = this.isInPopup ? this.getLayerBodyPosition.bottom : this.getWindowHeight+ this.getScrollTop;
      const targetOverflowTop = targetBottom < targetAreaTop;
      const targetOverflowBottom = targetTop > targetAreaBottom;
      // if(targetOverflowTop || targetOverflowBottom){
      //   this.fetchDropBoxEnd();
      // }

      // dropbox Position
      let top = dropBoxTop + this.spaceMargin + (this.isInPopup ? isInPopupScroll : 0);
      let bottom = this.getWindowHeight - elementOffset.top + this.spaceMargin - (this.isInPopup ? isInPopupScroll : 0);

      const dropOverflowViewTop = this.getWindowHeight - bottom - this.getScrollTop - this.dropBoxHeight < 0;
      const dropOverflowViewBottom = this.getWindowHeight+ this.getScrollTop - top  - this.dropBoxHeight < 0;
      if(dropOverflowViewTop && dropOverflowViewBottom){
        // console.log('중간')
        top = 'inherit';
        bottom = bottom - (this.dropBoxHeight /2);
      }
      else if(!dropOverflowViewTop && dropOverflowViewBottom){
        // console.log('위')
        top = 'inherit';
        bottom = bottom;
      }
      else{
        // console.log('아래')
        top = top;
        bottom = 'inherit';
      }
      this.dropBoxPosition.top= top;
      this.dropBoxPosition.bottom= bottom;
      this.dropBoxPosition.left= elementOffset.left;
      this.dropBoxPosition.width= this.getDropBoxTarget.offsetWidth;
      this.isLayer = this.getWindowWidth < elementOffset.left + this.$refs.innerBoxDrop.offsetWidth;
    },
    isActive(id,keyName){
      if(!this.getDropBoxValue) return false;
      return id === this.getDropBoxValue[keyName];
    },
    onClickOption(option,keyName){
      let resultObj = this.getDropBoxValue;
      resultObj[keyName] = option;
      // let result = `${resultObj.H}:${resultObj.M}:${resultObj.S}`;
      this.fetchDropBoxSelect(resultObj)
    },
    onClickDrop(){
      if(this.isLayer){
        this.fetchDropBoxEnd();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box_drop{position:absolute;overflow:hidden;top:var(--top);bottom:var(--bottom);left:var(--left);min-width:var(--width);z-index:300;max-height:0;opacity:0;transition:max-height 0.2s ease-in}
.inner_box_drop{overflow:hidden;border-radius:$CONTENT_RADIUS;border:1px solid $DEFAULT_BORDER;background-color:$FORM_BG;box-shadow:2px 4px 4px 0 rgba(0,0,0,.1)}
.inner_box_drop .list_option{display:inline-block;overflow:hidden;overflow-y:auto;width:33.33%;max-height:var(--height);padding:8px 0;vertical-align:top}

.btn_option{position:relative;display:block;width:100%;padding:12px 40px 12px 14px;font-size:14px;line-height:20px;text-align:left;letter-spacing:-.02em;white-space:nowrap}
.btn_option:hover{background-color:rgba($PRIMARY_COLOR,.1)}
.btn_option:disabled{background-color:$DISABLED_BG;cursor:default;color:$DISABLED_TEXT}
li.active .btn_option{font-weight:600;color:$PRIMARY_COLOR;background-color:rgba($PRIMARY_COLOR,.1)}
.btn_option .icon_check{position:absolute;top:50%;right:14px;margin-top:-6px}
.btn_option .desc_info + .txt_option{margin-top:2px}
.btn_option .txt_option + .desc_info{margin-top:6px}
.btn_option .txt_option{display:block}
.btn_option .desc_info{font-size:12px;line-height:14px;color:#888;letter-spacing:-.02em}

.area_empty{padding:28px 0;background-color:$DISABLED_BG}
.area_empty .desc_empty{color:$DISABLED_TEXT;text-align:center}

.box_drop.active{overflow:visible;max-height:1000px;opacity:1;transition:max-height 0.5s ease-out, opacity 0.2s;}
.box_drop.active .inner_box_select{box-shadow:0 2px 6px rgba(0,0,0,.2)}

.box_drop.box_drop_layer{position:fixed;top:0;bottom:0;left:0;right:0;width:100%;backdrop-filter:blur(1px);background-color:$DIMMED_BG;height:100%;max-height:inherit}
.box_drop.box_drop_layer .inner_box_drop{position:absolute;bottom:0;left:0;right:0;width:100%;border:0 none;border-radius:10px 10px 0 0;box-sizing:border-box;background-color:$DEFAULT_BG}

@media (prefers-color-scheme: dark) {
  .inner_box_drop{border-color:$PRIMARY_COLOR;background-color:$FORM_BG_DARK}
  .btn_option:disabled{background-color:$DISABLED_BG_DARK;color:$DISABLED_TEXT_DARK}
  .btn_option .icon_check ::v-deep g{fill:$PRIMARY_COLOR}

  .box_drop.box_drop_layer{background-color:$DIMMED_BG_DARK}
  .box_drop.box_drop_layer .inner_box_drop{background-color:$DEFAULT_BG_DARK}
}
</style>